import {
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  List,
  ListItem,
  Container,
} from "@mui/material";

export default function Solutions() {
  const solutions = [
    {
      icon: "",
      head: "Smarter Cost Allocation",
      subHead: "Assign Spend Without the Tagging Headache",
      para: "You don't need 100% tag coverage to understand your cloud spend. Our system intelligently filters and maps resources to custom cost centers—making financial reporting effortless.",
    },
    {
      icon: "",
      head: "Intelligent Cloud Cleanup",
      subHead: "Continuously Reduce Unused Cloud Spend",
      para: "From idle compute to oversized storage, our tools auto-detect and eliminate waste—ensuring every dollar spent drives value. Auto-actions or approval-based cleanup, depending on your control level",
    },
    {
      icon: "",
      head: "Adaptive Scaling Intelligence",
      subHead: "Smarter Autoscaling for Any Environment",
      para: "Seamlessly integrate with your autoscaling tool — EC2 we'll optimize how and when to scale, improving both performance and cost-efficiency.",
    },
    {
      icon: "",
      head: "Intelligent Resource Matching",
      subHead: "Always Choose the Right Instance Type",
      para: "We select the best instance types for your workloads—balancing performance and price—so engineers don't waste time guessing.",
    },
    {
      icon: "",
      head: "Built-in Fallback for Stability",
      subHead: "",
      para: "If spot capacity is unavailable or interrupted, we instantly fall back to on-demand or reserved instances, ensuring zero downtime and full reliability.",
    },
    {
      icon: "",
      head: "Precision in Scaling",
      subHead: " Intelligent, Self-Optimizing Scaling",
      para: "Our platform scales resources with real-time precision — allocating exactly what’s needed, no more, no less. Meanwhile, our AI learns from usage patterns to continuously improve performance and cost efficiency over time.",
    },
    // {
    //   icon: "",
    //   head: "Continuous Learning",
    //   subHead: "",
    //   para: "Our AI models are always evolving. The longer you use our platform, the more intelligent and efficient your resource allocation becomes — automatically.",
    // },
  ];

  return (
    <>
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          bgcolor: "#f9f9f9",
          pb: 2,
        }}
      >
        {/* Background Gradient Block */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #6E73F2 0%, #9C4DF4 100%)",
            height: "400px",
            borderBottomLeftRadius: "100px",
            borderBottomRightRadius: "100px",
            position: "relative",
          }}
        >
          {/* Optional decorative element (e.g., constellation dots) */}
          <Box
            sx={{
              position: "absolute",
              top: 40,
              left: 60,
              color: "white",
              opacity: 0.2,
            }}
          >
            ✨ ★ ✨
          </Box>

          <Container sx={{ pt: 8, textAlign: "center", color: "white" }}>
            <Typography
              fontWeight="bold"
              sx={{
                fontSize: { lg: "3em", xs: "1.6em" },
                fontFamily: '"marcellus", sans-serif',
              }}
            >
              Intelligent Solutions
            </Typography>
            <Typography
              color="text.secondary"
              sx={{
                maxWidth: 800,
                mx: "auto",
                color: "white",
                fontSize: { lg: "1.2em", xs: "1em" },
              }}
            >
              Our AI-powered platform provides comprehensive tools to analyze,
              optimize, and automate your cloud spending.
            </Typography>
          </Container>
        </Box>

        {/* Pricing Cards Layered On Top */}
        <Grid
          sx={{
            mt: -17,
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            position: "relative",
          }}
        >
          <Grid
            container
            spacing={{ lg: 10, sm: 7, xs: 4 }}
            direction="row"
            justifyContent="center"
          >
            {solutions.map((item, index) => (
              <Grid item key={index} xs={12} md={4} lg={4} sm={2}>
                <Card
                  sx={{
                    // height: { lg: "100%", xs: "30vh", sm: "36vh" },
                    height: "100%",
                    borderRadius: "17px",
                    width: { lg: "26vw", xs: "86vw", sm: "42vw" },
                    boxShadow: "0 4px 16px rgba(89, 88, 88, 0.15)",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
                    },
                  }}
                >
                  <CardContent sx={{ p: { lg: 4, xs: 3 } }}>
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        fontWeight: "bold",
                        fontFamily: '"marcellus", sans-serif',
                      }}
                      gutterBottom
                    >
                      {item.head}
                    </Typography>
                    <Box sx={{ mb: { lg: 2, xs: 1 } }}>
                      <Typography variant="button" color="text.secondary">
                        {item.subHead}
                      </Typography>
                    </Box>
                    <List disablePadding>
                      <ListItem disableGutters disablePadding>
                        <Typography variant="body2">{item.para}</Typography>
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
